// src/sections/OurPlatters/OurPlatters.js
import React from 'react';
import styles from './OurPlatters.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as solidHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as regularHeart } from '@fortawesome/free-regular-svg-icons';

const plattersData = [
  { 
    id: "platter-2-persons-share", 
    name: "PLATEAU DÉGUSTATION (2 personnes, 14 pcs)", 
    price: "20,00 €", 
    description: "Contenu : 2 portions de riz parfumé, nems poulet x2, nems crevettes x2, jalapenos x2, crevettes panko x2, brochettes poulet ananas x2, brochettes poulet teriyaki x2, samoussas x2." 
  },
  { 
    id: "plat-nems-poulet-5pcs", 
    name: "NEMS POULET (5 pièces accompagnées de riz parfumé)", 
    price: "9,50 €", 
    description: "" 
  },
    { 
    id: "plat-nems-crevettes-5pcs", 
    name: "NEMS CREVETTES (5 pièces accompagnées de riz parfumé)", 
    price: "9,50 €", 
    description: "" 
  },
      { 
    id: "plat-jalapenos-5pcs", 
    name: "JALAPENOS (5 pièces accompagnées de riz parfumé)", 
    price: "9,50 €", 
    description: "" 
  },
      { 
    id: "plat-Samoussas-4pcs", 
    name: "SAMOUSSAS (4 pièces accompagnées de riz parfumé)", 
    price: "9,50 €", 
    description: "" 
  },
      { 
    id: "plat-brochettes-poulet-teriyaki-5pcs", 
    name: "BROCHETTES POULET TERIYAKI (5 pièces accompagnées de riz parfumé)", 
    price: "9,50 €", 
    description: "" 
  },
      { 
    id: "plat-brochettes-poulet-ananas-5pcs", 
    name: "BROCHETTES POULET ANANAS (5 pièces accompagnées de riz parfumé)", 
    price: "9,50 €", 
    description: "" 
  },
        { 
    id: "plat-crevettes-panko-5pcs", 
    name: "CREVETTES PANKO (6 pièces accompagnées de riz parfumé)", 
    price: "9,50 €", 
    description: "" 
  },
  
];

// Le composant reçoit les props favorites, addFavorite, removeFavorite de App.js
const OurPlatters = ({ id, favorites, addFavorite, removeFavorite }) => {

  const isFavorite = (item) => {
    return favorites.some(favItem => favItem.id === item.id);
  };

  const handleFavoriteClick = (item) => {
    if (isFavorite(item)) {
      removeFavorite(item.id);
    } else {
      addFavorite(item);
    }
  };

  return (
    <section id={id} className={styles.ourPlatters}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>NOS PLATEAUX</h2>
        <p className={styles.subtitle}>À PARTAGER</p>
        
        <div className={styles.menuList}>
          {plattersData.map((item) => (
            <div key={item.id} className={styles.menuItem}>
              <div className={styles.itemHeader}>
                <span className={styles.itemName}>{item.name}</span>
                <span className={styles.itemSeparator}></span>
                
                {/* NOUVEAU WRAPPER POUR LE PRIX ET LE BOUTON FAVORIS */}
                <div className={styles.priceAndFavorite}>
                  <span className={styles.itemPrice}>{item.price}</span>
                  <button
                    className={`${styles.favoriteButton} ${isFavorite(item) ? styles.isFavorite : ''}`}
                    onClick={() => handleFavoriteClick(item)}
                    aria-label={isFavorite(item) ? `Retirer ${item.name} des favoris` : `Ajouter ${item.name} aux favoris`}
                  >
                    <FontAwesomeIcon icon={isFavorite(item) ? solidHeart : regularHeart} />
                  </button>
                </div>

              </div>
              {item.description && (
                <p className={styles.itemDescription}>{item.description}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurPlatters;